import { BenchmarkScoreCategory, CategoryActivityItem } from '../../../../../models'

export const benchmarkingSelectOptions = ['All Industries', 'Financial Services', 'Information Security']

// The benchmark endpoint sorts categories alphabetically by their slug id, which strands Threat
// Detection (id `detection-and-response`) mid-list. Reorder against the category activity feed so
// Benchmarking matches the order the rest of the dashboard renders.
export const sortCategoriesByActivityOrder = (
  categories: BenchmarkScoreCategory[],
  reference: CategoryActivityItem[]
): BenchmarkScoreCategory[] => {
  if (!reference.length) return categories

  const rankById = new Map(reference.map((item, index) => [item.id, index]))
  const rankByName = new Map(reference.map((item, index) => [item.name, index]))

  // Categories the feed doesn't know about keep their relative order, after the ones it does
  const rank = (category: BenchmarkScoreCategory) =>
    rankById.get(category.category_id) ?? rankByName.get(category.category_name) ?? Number.MAX_SAFE_INTEGER

  return [...categories].sort((a, b) => rank(a) - rank(b))
}
